export default __webpack_public_path__ + "static/media/Browser.a272de92.svg";